import React, {Component} from 'react';
import S from 'StyledAccountEditProfile.js';

class AccountEditProfile extends Component {

};

export default AccountEditProfile;